import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { ThankYou } from './pages/ThankYou';
import { HolidaySpecial } from './pages/HolidaySpecial';
import { HolidayBanner } from './components/HolidayBanner';
import { FloatingChatWidget } from './components/FloatingChatWidget';
import { initGA4 } from './analytics';

function App() {
  useEffect(() => {
    // Initialize Google Analytics 4
    initGA4();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <HolidayBanner />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/confirmation" element={<ThankYou />} />
          <Route path="/holiday-special" element={<HolidaySpecial />} />
        </Routes>
        <FloatingChatWidget />
      </BrowserRouter>
    </div>
  );
}

export default App;